"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var CardSizeStyles = (_a = {},
    _a['small'] = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 16px;\n    border-radius: 16px;\n  "], ["\n    padding: 16px;\n    border-radius: 16px;\n  "]))),
    _a['medium'] = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 24px;\n    border-radius: 20px;\n  "], ["\n    padding: 24px;\n    border-radius: 20px;\n  "]))),
    _a['large'] = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 32px;\n    border-radius: 24px;\n  "], ["\n    padding: 32px;\n    border-radius: 24px;\n  "]))),
    _a);
var StyledCard = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  border: ", ";\n  ", ";\n"], ["\n  background-color: ", ";\n  border: ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.card;
}, function (_a) {
    var theme = _a.theme;
    return "1px solid ".concat(theme.colors.border.secondary);
}, function (_a) {
    var $size = _a.$size;
    return CardSizeStyles[$size];
});
/**
 * A basic surface component which should contain content and / or actions about a single subject.
 */
var Card = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, props = __rest(_a, ["children", "size"]);
    return (react_1.default.createElement(StyledCard, __assign({ "$size": size }, props), children));
};
exports.Card = Card;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
